

















import { Component, Vue } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';

@Component({
  components: {
    Banner
  }
})
export default class CFP extends Vue {
  public mounted () {
    const title = document.querySelector('head>title');
    const metaList = Array.from(document.querySelectorAll('head>meta'));

    if (title) {
      title.innerHTML = 'COSCUP 2019 來台講 -- 世界頭一擺ê台語專場科技研討會';
    }

    metaList[3].setAttribute('content', 'COSCUP 2019 來台講 -- 世界頭一擺ê台語專場科技研討會');
    metaList[5].setAttribute('content', 'https://coscup.org/taigi2019/cfp');
    metaList[6].setAttribute('content', 'https://coscup.org/taigi2019/img/og.png');
  }
}
